import _isFunction from "lodash/isFunction";
import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { paperContainer, paperContentContainer, paperHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Paper = function Paper(props) {
  var children = props.children,
      header = props.header,
      className = props.className;
  return ___EmotionJSX("div", _extends({
    css: paperContainer(props)
  }, className && {
    className: className
  }), header && (_isFunction(header) ? header({
    css: paperHeaderContainer(props)
  }) : ___EmotionJSX("div", {
    css: paperHeaderContainer(props)
  }, ___EmotionJSX("h5", null, header))), ___EmotionJSX("div", {
    css: paperContentContainer(props)
  }, children));
};

Paper.propTypes = {
  children: PropTypes.any,
  header: PropTypes.any,
  className: PropTypes.string
};
export default Paper;